(ns ui.editors.card.property-list.event
  (:require [re-frame.core :as rf]
            [common.util :as cu]
            [ui.editors.card.property-list.model :as model]
            [ui.editors.card.model :as common-model]
            [potpuri.core :as p]))

(rf/reg-event-db
 ::add-card-row
 (fn [db _]
   (let [prev-rows (model/get-rows-db db)
         new-rows (-> prev-rows
                      (conj {:cells [model/empty-cell]})
                      (vec))]
     (model/set-rows-db db new-rows))))

(rf/reg-event-db
 ::add-card-row-cell
 (fn [db [_ row-index]]
   (let [prev-rows (model/get-rows-db db)
         new-rows (->> prev-rows
                       (map-indexed
                        (fn [idx row]
                          (if (= idx row-index)
                            (let [prev-cells (:cells row)
                                  new-cells (conj prev-cells model/empty-cell)]
                              (assoc row :cells new-cells))
                            row)))
                       (vec))]
     (model/set-rows-db db new-rows))))

(rf/reg-event-db
 ::remove-card-row-cell
 (fn [db [_ row-index cell-index]]
   (let [prev-row (model/get-row-db db row-index)
         prev-cells (:cells prev-row)
         new-cells (cu/remove-from-index cell-index prev-cells)
         prev-rows (model/get-rows-db db)
         new-rows (->> prev-rows
                       (map-indexed (fn [idx row]
                                      (if (= idx row-index)
                                        (assoc row :cells new-cells)
                                        row)))
                       (filter (fn [row]
                                 (seq (:cells row))))
                       (vec))]
     (model/set-rows-db db new-rows))))

(rf/reg-event-db
 ::set-cell-width
 (fn [db [_ row-index cell-index width]]
   (model/set-cell-width-db db row-index cell-index width)))

(rf/reg-event-db
 ::set-cell-field
 (fn [db [_ row-index cell-index field]]
   (let [missing-field-error? (get-in db (model/->cell-validation-error-missing-field-full-path row-index cell-index))]
     (cond-> db
       true
       (model/set-cell-property-db row-index cell-index :field field)

       (and field  missing-field-error?)
       (p/dissoc-in (model/->cell-validation-error-missing-field-full-path row-index cell-index))))))

(rf/reg-event-db
 ::set-cell-always-visible
 (fn [db [_ row-index cell-index always-visible?]]
   (model/set-cell-property-db db row-index cell-index :always-visible? always-visible?)))

(rf/reg-event-db
 ::set-cell-empty-cell-value
 (fn [db [_ row-index cell-index empty-cell-value]]
   (model/set-cell-property-db db row-index cell-index :empty-cell-value empty-cell-value)))

(rf/reg-event-db
 ::move-cell-horizontally
 (fn [db [_ row-index cell-index direction]]
   (assert (contains? #{:left :right} direction) (str "Not valid direction " direction))
   (let [row (model/get-row-db db row-index)
         cells (:cells row)
         cell-to-move (nth cells cell-index)
         other-cell-index (if (= direction :left)
                            (dec cell-index)
                            (inc cell-index))
         other-cell (nth cells other-cell-index)
         cell-validation-errors (model/get-cell-validation-errors-db db row-index cell-index)
         other-cell-validation-errors (model/get-cell-validation-errors-db db row-index other-cell-index)
         new-cells (-> cells
                       (assoc cell-index other-cell)
                       (assoc other-cell-index cell-to-move))
         new-row (assoc row :cells new-cells)]
     (-> db
         (model/set-row-db row-index new-row)
         (model/set-cell-validation-errors-db row-index other-cell-index cell-validation-errors)
         (model/set-cell-validation-errors-db row-index cell-index other-cell-validation-errors)))))
